module.exports = __webpack_public_path__ + "img/icon-jianxiaoshijian@2x.4b38b08c.png";